export const TOASTER_VARIANT = {
    SUCCESS: "success",
    ERROR: 'error',
    INFO: 'info',
    WARNING: 'warn',
}